function scrollToElement(jqElement, extraOffset) {
  var scrollValue = jqElement.offset().top;
  if (extraOffset) {
    scrollValue += parseInt(extraOffset);
  }
  $([document.documentElement, document.body]).animate({
    scrollTop: scrollValue
  }, 500);
}

function needsAnalysis() {
  var na = this;
  var itemsWrapper = null;
  var resultItemsWrapper = null;
  var items = [];
  var resultItems = [];
  var itemCount = 0;
  var resultItemsCount = 0;
  var positionIndicators = null;
  var pos = 0;
  var controlsWrapper = null;
  var isAnyItemConditioned = null;

  function toJq(el) {
    if (el instanceof jQuery) {
      return el;
    }

    return $(el);
  }

  var currentItem = function () {
    return items[pos];
  }

  var getItemByFieldId = function (fieldId) {
    var foundItems = $.grep(items, function (item, idx) {
      return item.key === fieldId;
    });

    if (foundItems && foundItems.length > 0) {
      return foundItems[0];
    }

    return null;
  }

  var isConditioned = function () {
    if (isAnyItemConditioned !== null) {
      return isAnyItemConditioned;
    }

    for (var index = 0; index < items.length; index++) {
      var slideItem = items[index];
      if (slideItem.condition) {
        isAnyItemConditioned = true;
        return isAnyItemConditioned;
      }

    }
    isAnyItemConditioned = false;
    return isAnyItemConditioned;
  }

  var getNextVisibleIndex = function (currentPos) {
    var startIndex = Math.min(currentPos + 1, items.length - 1);
    for (var index = startIndex; index < items.length; index++) {
      var slideItem = items[index];
      if (slideItem.visible) {
        return index;
      }
    }
    return currentPos;
  }

  var getPreviousVisibleIndex = function (currentPos) {
    var startIndex = Math.max(currentPos - 1, 0);
    for (var index = startIndex; index >= 0; index--) {
      var slideItem = items[index];
      if (slideItem.visible) {
        return index;
      }
    }
    return currentPos;
  }

  var updateItemVisibility = function () {
    if (!isConditioned()) {
      return;
    }
    for (var index = 0; index < items.length; index++) {
      var slideItem = items[index];
      if (slideItem.visible) {
        slideItem.$slide.removeClass('conditionalhidden');
      } else {
        slideItem.$slide.addClass('conditionalhidden');
      }

    }


  }

  var resultItem = function (el) {
    var myobj = this;
    this.$el = toJq(el);
    this.resultType = null;
    this.suggestionPanel = this.$el.find('.indicator-suggestion-container');
    this.conversionPanel = this.$el.find('.indicator-suggestion-conversion')
    this.needsAnalysisId = this.$el.closest('.needs-analysis').data('id');
    this.workflowObj = this.$el.closest('.needs-analysis-workflow-obj');
    this.workflowId = 'wf1';
    if (this.workflowObj.hasClass('wf2')) {
      this.workflowId = 'wf2';
    }

    function getResultEvaluationId() {
      var result = myobj.$el.find('[data-id]').data('id');
      return result;
    }

    function jq() {
      return myobj.$el;
    }

    var setAnswers = function (answers) {
      myobj.$el.find('.answers').val(answers);
    }

    var setResults = function (results) {
      myobj.$el.find('.results').val(results);
    }

    var initResultItem = function () {
      if (myobj.resultType === null) {
        myobj.resultType = myobj.$el.find('[data-typeid]').data('typeid');
      }

      var fnname = myobj.resultType + '_init';
      if (typeof resultItem.prototype[fnname] === 'function') {
        myobj[fnname]();
      }
    }

    initResultItem();

    return {
      needsAnalysisId: this.needsAnalysisId,
      workflowId: this.workflowId,
      getResultEvaluationId: getResultEvaluationId,
      jQ: jq,
      setAnswers: setAnswers,
      setResults: setResults
    };
  }

  //resultItem.prototype.
  resultItem.prototype.needsanalysisresultindicatorblock_init = function () {
    var self = this;
    this.$el.find('.cta-form-toggler').on('click', function () {
      if (self.suggestionPanel.is(':visible')) {
        self.suggestionPanel.fadeOut(200, function () {
          self.conversionPanel.fadeIn(200);
        });
      }
    })
  }

  resultItem.prototype.needsanalysisresultproductblock_init = function () {
    this.$el.find('.indicator-robot-content').on('click', '.readmore', function () {
      var readmoreBtn = $(this);
      var body = readmoreBtn.prev('.body');
      readmoreBtn.fadeOut(50, function () {
        if (body.is(':visible')) {
          body.slideUp(100, function () {
            readmoreBtn.removeClass('open');
            readmoreBtn.fadeIn(50);
          });

        } else {
          body.slideDown(100, function () {
            readmoreBtn.addClass('open');
            readmoreBtn.fadeIn(50);
          });
        }
      });
    })
  }

  var slideItem = function (el) {
    var myobj = this;
    this.$slide = toJq(el);
    this.slideId = null;
    this.slideType = null;
    this.question = null;
    this.required = false;
    this.condition = null;

    var getSlideId = function () {
      if (myobj.slideId === null) {
        myobj.slideId = myobj.$slide.find('[data-fieldid]').data('fieldid');
      }

      return myobj.slideId;
    }

    var slideRequired = function () {
      var requiredAttr = myobj.$slide.find('[data-sliderequired]').data('sliderequired');
      if (requiredAttr) {
        myobj.required = typeof requiredAttr === 'boolean' && requiredAttr || requiredAttr === 'true';
      }
      else {
        myobj.required = false;
      }
    }

    var slidecondition = function () {
      var conditionAttr = myobj.$slide.find('[data-slidecondition]').data('slidecondition')
      if (conditionAttr) {
        myobj.condition = conditionAttr;
      }
    }

    var isVisibleByCondition = function () {
      if (!myobj.condition) {
        return true;
      }

      var conditionItems = myobj.condition.split(':');

      if (conditionItems.length !== 2) {
        return true;
      }

      var referencedSlideItem = getItemByFieldId(conditionItems[0]);

      if (referencedSlideItem === null) {
        return true;
      }

      var refDto = referencedSlideItem.toDto();
      return refDto.value.numericValue === parseInt(conditionItems[1]) || refDto.value.textValue === conditionItems[1];


    }

    var initSlide = function () {

      myobj.question = myobj.$slide.find('h3').text();

      if (myobj.slideType === null) {
        myobj.slideType = myobj.$slide.find('[data-typeid]').data('typeid');
      }

      slideRequired();
      slidecondition();

      var fnname = myobj.slideType + '_init';
      if (typeof slideItem.prototype[fnname] === 'function') {
        myobj[fnname]();
      }
    }

    var getSlideValue = function () {
      if (myobj.slideType === null) {
        myobj.slideType = myobj.$slide.find('[data-typeid]').data('typeid');
      }

      if (typeof slideItem.prototype[myobj.slideType] === 'function') {
        return myobj[myobj.slideType]();
      }

      return 0;
    }

    var getSlideTextValue = function () {
      if (myobj.slideType === null) {
        myobj.slideType = myobj.$slide.find('[data-typeid]').data('typeid');
      }

      var fnname = myobj.slideType + '_text';
      if (typeof slideItem.prototype[fnname] === 'function') {
        return myobj[fnname]();
      }

      return '0';
    }

    var toDto = function () {
      return {
        key: getSlideId(),
        value: {
          numericValue: getSlideValue(),
          textValue: getSlideTextValue()
        }
      }
    }

    initSlide();

    return {
      key: getSlideId(),
      value: {
        get numericValue() { return getSlideValue(); },
        get textValue() { return getSlideTextValue(); }
      },
      $slide: this.$slide,
      toDto: toDto,
      question: this.question,
      required: this.required,
      condition: this.condition,
      get visible() { return isVisibleByCondition(); }
    }
  }

  //needsanalysisfreetextitemblock
  slideItem.prototype.needsanalysisfreetextitemblock = function () {
    return 0;
  }

  slideItem.prototype.needsanalysisfreetextitemblock_text = function () {
    return this.$slide.find('textarea').val();
  }

  //needsanalysischeckboxitemblock
  slideItem.prototype.needsanalysischeckboxitemblock = function () {
    var result = 0;
    var checkedItems = this.$slide.find('input[type=checkbox]:checked');
    if (!checkedItems) {
      return result;
    }
    checkedItems.each(function (idx, item) {
      result += parseInt($(item).val());
    });
    return result;
  }

  slideItem.prototype.needsanalysischeckboxitemblock_text = function () {
    var result = '';
    var checkedItems = this.$slide.find('input[type=checkbox]:checked');
    if (!checkedItems) {
      return result;
    }
    checkedItems.each(function (idx, item) {
      result += $(item).closest('label').children('.na-text-value').text() + '|';
    });
    return result;
  }


  //needsanalysisonascaleblock
  slideItem.prototype.needsanalysisonascaleblock = function () {
    var result = 0;
    var checkedItems = this.$slide.find('input[type=radio]:checked');
    if (!checkedItems) {
      return result;
    }
    checkedItems.each(function (idx, item) {
      result += parseInt($(item).val());
    });
    return result;
  }

  slideItem.prototype.needsanalysisonascaleblock_text = function () {
    var result = '';
    var checkedItems = this.$slide.find('input[type=radio]:checked');
    if (!checkedItems) {
      return result;
    }
    checkedItems.each(function (idx, item) {
      result += $(item).closest('label').children('.na-text-value').text();
    });
    return result;
  }


  //needsanalysisradiobuttonitemblock
  slideItem.prototype.needsanalysisradiobuttonitemblock = function () {
    var result = 0;
    var checkedItems = this.$slide.find('input[type=radio]:checked');
    if (!checkedItems) {
      return result;
    }
    checkedItems.each(function (idx, item) {
      result += parseInt($(item).val());
    });
    return result;
  }

  slideItem.prototype.needsanalysisradiobuttonitemblock_text = function () {
    var result = '';
    var checkedItems = this.$slide.find('input[type=radio]:checked');
    if (!checkedItems) {
      return result;
    }
    checkedItems.each(function (idx, item) {
      result += $(item).closest('label').children('.na-text-value').text();
    });
    return result;
  }



  //needsanalysissinglerangesliderblock
  slideItem.prototype.needsanalysissinglerangesliderblock_init = function () {
    var slider = this.$slide.find('.single-slider');
    var startValue = slider.data('defaultvalue');
    var minValue = slider.data('minvalue');
    var maxValue = slider.data('maxvalue');
    var stepValue = slider.data('sliderstep');
    var valueHolder = this.$slide.find('.slider-value');
    valueHolder.text(startValue);

    noUiSlider.create(slider[0], {
      start: [startValue],
      connect: true,
      step: stepValue,
      range: {
        'min': minValue,
        'max': maxValue
      },
      format: wNumb({ decimals: 0 })
    });

    slider[0].noUiSlider.on('update', function (values, handle) {
      valueHolder.text(values[handle]);
    });
  }

  slideItem.prototype.needsanalysissinglerangesliderblock = function () {
    var valueHolder = this.$slide.find('.slider-value');
    if (valueHolder.length > 0) {
      return parseInt(valueHolder.text());
    }

    return 0;
  }

  slideItem.prototype.needsanalysissinglerangesliderblock_text = function () {
    var valueHolder = this.$slide.find('.slider-value');
    if (valueHolder.length > 0) {
      return valueHolder.text();
    }

    return '';
  }

  //needsanalysisdualrangesliderblock
  slideItem.prototype.needsanalysisdualrangesliderblock_init = function () {
    var slider = this.$slide.find('.dual-slider');
    var startValue = slider.data('defaultvalue');
    var startValue2 = slider.data('defaultvalue2');
    var minValue = slider.data('minvalue');
    var maxValue = slider.data('maxvalue');
    var stepValue = slider.data('sliderstep');
    var valueHolder = this.$slide.find('.slider-value');


    noUiSlider.create(slider[0], {
      start: [startValue, startValue2],
      connect: true,
      step: stepValue,
      range: {
        'min': minValue,
        'max': maxValue
      },
      format: wNumb({ decimals: 0 })
    });

    valueHolder.text(slider[0].noUiSlider.get());
    slider[0].noUiSlider.on('update', function (values, handle) {
      valueHolder.text(values[0] + ' - ' + values[1]);
    });
  }

  slideItem.prototype.needsanalysisdualrangesliderblock = function () {
    var slider = this.$slide.find('.dual-slider');

    var currentValue = slider[0].noUiSlider.get();

    if (Array.isArray(currentValue)) {
      return currentValue.join(':');
    }

    return currentValue;
  }

  slideItem.prototype.needsanalysisdualrangesliderblock_text = function () {
    var slider = this.$slide.find('.dual-slider');

    var currentValue = slider[0].noUiSlider.get();

    var valueHolder = this.$slide.find('.slider-value');

    var suffix = null;
    if (valueHolder.attr('data-valuesuffix')) {
      suffix = ' ' + valueHolder.attr('data-valuesuffix');
    }

    var result = '';
    if (Array.isArray(currentValue)) {
      result = currentValue.join(' - ');
    } else {
      result = currentValue;
    }

    if (suffix) {
      result += suffix;
    }

    return result;
  }

  //needsanalysisdropdownblock
  slideItem.prototype.needsanalysisdropdownblock_init = function () {
    var select = this.$slide.find('select');
    select.select2({ minimumResultsForSearch: Infinity });
  }

  slideItem.prototype.needsanalysisdropdownblock = function () {
    var select = this.$slide.find('select');
    return select.find(':selected').val();
  }

  slideItem.prototype.needsanalysisdropdownblock_text = function () {
    var select = this.$slide.find('select');
    return select.find(':selected').text();
  }




  function getItemValues() {
    var result = [];
    for (var index = 0; index < items.length; index++) {
      var $slide = items[index];
      result.push($slide.toDto());
    }
    return result;
  }


  function removeCssClass(baselement, selector, content) {
    toJq(baselement).find(selector).removeClass(content);
  }

  function setCssClass(baselement, selector, content, withreset) {
    var $el = toJq(baselement).find(selector);
    if (withreset) {
      var resetvalue = $el.data('classreset');
      $el.attr('class', resetvalue);
    }

    $el.addClass(content);
  }

  function setContent(baselement, selector, content) {
    toJq(baselement).find(selector).html(content);
  }

  function updateResult(evalationResponse) {
    var resultItem = resultItems[0];
    var resultElement = resultItem.jQ();

    if (evalationResponse.resultClass) {
      setCssClass(resultElement, '.js-result-class', evalationResponse.resultClass, true);
    }

    if (evalationResponse.primaryContent) {
      setContent(resultElement, '.js-primary-content', atob(evalationResponse.primaryContent));
    }

    if (evalationResponse.secondaryContent) {
      setContent(resultElement, '.js-secondary-content', atob(evalationResponse.secondaryContent));
    }

    var answers = '';
    for (var index = 0; index < items.length; index++) {
      var slideitemObj = items[index];
      answers += slideitemObj.question + ':\n ' + slideitemObj.value.textValue + '\n\n';
    }

    resultItem.setAnswers(answers);
    var results = '';
    if (evalationResponse.primaryContent) {
      results += atob(evalationResponse.primaryContent) + ' \n'
    }
    if (evalationResponse.secondaryContent) {

      atob(evalationResponse.secondaryContent);
    }

    results = $('<div>' + results + '</div>').text();

    resultItem.setResults(results);
  }

  function sendItemsOffScreen() {
    var totalWidth = 0;
    toJq(items).each(function (idx, item) {
      totalWidth += item.$slide.outerWidth(true);
    });

    totalWidth += 200;

    itemsWrapper.css('transform', 'translateX(' + (-1 * (totalWidth)) + 'px)');
    itemsWrapper.addClass('offscreen');
  }

  function showresult() {
    sendItemsOffScreen();
    controlsWrapper.addClass('backonly');
    resultItemsWrapper.addClass('onscreen');

  }

  function checkRequired() {
    var result = -1;
    for (var index = 0; index < items.length; index++) {
      var slideItem = items[index];
      if (!slideItem.required) {
        continue;
      }

      var slideDto = slideItem.toDto();
      if (slideItem.visible && slideDto.value.numericValue === 0 && (slideDto.value.textValue === '0' || slideDto.value.textValue === '')) {
        return index;
      }

    }

    return result;
  }


  function evaluate() {
    var required = checkRequired();
    if (required >= 0) {
      goto(required);
      currentItem().$slide.addClass('invalid');
      return;
    }

    var ri = resultItems[0];
    var data = {
      needsAnalysisId: ri.needsAnalysisId,
      workflowId: ri.workflowId,
      resultEvaluationId: ri.getResultEvaluationId(),
      values: getItemValues()
    }

    $.post('/api/needsanalysis/evaluate', data, function (response, status, xhr) {
      updateResult(response);
    }).fail(function (err) {
      updateResult({ primaryContent: window.btoa(err.responseJSON.error) })
    })
      .always(function () {
        showresult();
      })

  }

  function setTransform() {

    var offsetSum = 0;
    for (var index = 0; index < pos; index++) {
      var refSlide = items[index];

      var refItem = refSlide.$slide;

      var left = parseInt(refItem.css('margin-left')) + parseInt(refItem.css('padding-left'));
      var right = parseInt(refItem.css('margin-right')) + parseInt(refItem.css('padding-right'));
      var offset = left + right;
      var width = refItem.width();
      offsetSum += width + offset;
    }

    itemsWrapper.css('transform', 'translateX(' + (-1 * (offsetSum)) + 'px)');
  }

  function goto(index) {
    if (resultItemsWrapper.hasClass('onscreen')) {
      resultItemsWrapper.removeClass('onscreen');
      itemsWrapper.removeClass('offscreen');
    }
    pos = index;
    setTransform();
    setActiveIndicator(index);
    updateView();
  }

  function setActiveIndicator(index) {
    positionIndicators.removeClass('active');
    $(positionIndicators[index]).addClass('active');
  }

  function prev() {
    if (resultItemsWrapper.hasClass('onscreen')) {
      resultItemsWrapper.removeClass('onscreen');
      itemsWrapper.removeClass('offscreen');
      pos = itemCount;
    }
    pos = getPreviousVisibleIndex(pos);
    setTransform();
    setActiveIndicator(pos);
    updateView();
  }

  function next() {
    updateItemVisibility();
    pos = getNextVisibleIndex(pos);
    setTransform();
    setActiveIndicator(pos);
    updateView();
  }

  function updateView() {
    controlsWrapper.removeClass('backonly');
    if (pos == itemCount - 1) {
      controlsWrapper.addClass('onlast');
    } else {
      controlsWrapper.removeClass('onlast');
    }

  }



  var initNeedsAnalysis = function (el) {
    var $el = $(el);
    itemsWrapper = $el.find('.needs-analysis-workflow-items');
    itemsWrapper.children().each(function (idx, slide) {
      items.push(new slideItem(slide));
    });
    itemCount = items.length;
    resultItemsWrapper = $el.find('.needs-analysis-workflow-result-items');
    resultItemsWrapper.children().each(function (idx, resultSlide) {
      resultItems.push(new resultItem(resultSlide));
    });
    resultItemsCount = resultItems.length;
    controlsWrapper = $el.children('.controls');


    var positionIndicator = $el.children('.needs-analysis-positionindicator');
    if (isConditioned()) {
      positionIndicator.addClass('hide');
      updateItemVisibility();
    }

    positionIndicators = positionIndicator.children();
    positionIndicators.on('click', function () {
      var index = $(this).data('positionindex');
      goto(index);
      return false;
    });
    positionIndicators.first().addClass('active');

    var nextButton = $el.find('.js-na-next');
    nextButton.on('click', function () {
      next();
      return false;
    })

    var prevLink = $el.find('.js-na-prev');
    prevLink.on('click', function () {
      prev();
      return false;
    })

    var evaluateButton = $el.find('.js-na-evaluate');
    evaluateButton.on('click', function () {
      evaluate();
    })
  }

  return {
    initNeedsAnalysis: initNeedsAnalysis
  }
}

function needsAnalysisDashboard() {
  var $dashboard = null;
  var $workflowcontainer = null;

  function openWorkflow(wf) {
    if ($workflowcontainer.hasClass('open-' + wf)) {
      return;
    }

    $workflowcontainer.removeClass('open-wf1');
    $workflowcontainer.removeClass('open-wf2');
    $workflowcontainer.addClass('open-' + wf);
    $workflowcontainer.addClass('open');
  }

  function initButtons() {
    var marginTopBlock = parseFloat($workflowcontainer.find('.block').first().css('margin-top'));
    $dashboard.find('button').on('click', function () {
      var btn = $(this);
      var open = btn.data('open');
      openWorkflow(open);

      var headerHeight = $('#header').height();
      var blockHeadlineOffset = 21;
      var extraOffset = -1 * (headerHeight + blockHeadlineOffset) + marginTopBlock;
      scrollToElement($workflowcontainer, extraOffset);
    })
  }

  var initNeedsAnalysisDashboard = function (el) {
    $dashboard = $(el);
    $workflowcontainer = $(el).next('.needs-analysis-workflow');
    initButtons();
  }

  return {
    initNeedsAnalysisDashboard: initNeedsAnalysisDashboard
  };
}

(function ($, document, window) {
  $(document).ready(function () {
    noUiSlider.cssClasses.target += ' na-slider';
    $('.needs-analysis-workflow-obj').each(function (idx, el) {
      var na = new needsAnalysis();
      na.initNeedsAnalysis(el);
    });

    $('.needs-analysis-dashboard').each(function (idx, el) {
      var nad = new needsAnalysisDashboard();
      nad.initNeedsAnalysisDashboard(el);
    });
  });
}(jQuery, document, window));

